import { getAllowedDeviceFeaturesUrl } from "ECD/NGIApiUrls";
import { getToken } from "Global/AppService";
import { rateLimitErrorHandler } from 'Common/components/GenericErrorHandler';

var AuthorizationService = {
 
    async fetchAllowedFeaturesForDevice(instanceId, callback) {
      
      var urlObject = getAllowedDeviceFeaturesUrl(instanceId);
      console.log('invoking auth url to fetch allowedDevices, url- ' + urlObject.url + ",instance- " + instanceId);
      var timeout = 60000;
      var contentType = "application/json; charset=utf-8";
      $.ajax({
        url: urlObject.url,
       
        headers: {
           'Authorization':  "Bearer "+await getToken(),
          },
        type: "get",
        dataType: "json",
        timeout: timeout,
        contentType: contentType,
        processData: false,
        success: function (success) {
          console.log('auth url to fetch allowedDevices succeeded ############');
          callback(success);
        },
        error: function (err) {
          console.log("<--------------- Error ------------------>", err);
          if(err.status == 403 && err.responseText && err.responseText.includes("Gateway")){
            rateLimitErrorHandler();
          }else{
            callback("", err);   
          }
        },
        cache: false,
        crossDomain: true,
      });
    },
};

export default AuthorizationService;


   